<div class="section-header" [class.danger-header]="!!data['warningHtml']" mat-dialog-title>
    <mat-icon class="section-icon">{{ data['warningHtml'] ? 'warning' : 'question_answer' }}</mat-icon>
    <span class="section-title">{{ 'general.confirmation' | transloco }}</span>
    <button mat-icon-button class="ss-dialog-close-btn" mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<div mat-dialog-content>
    @if (data['titleHtml']) {
        <div class="message-content" [innerHTML]="data['titleHtml']"></div>
    } @else {
        <div class="message-content">{{ data['name'] }}</div>
    }
    @if (data['warningHtml']) {
        <div class="warning-box" [innerHTML]="data['warningHtml']"></div>
    }
    @if (data?.options?.showCancel || data['showCancel']) {
        <div class="action-buttons">
            <div fxFlex fxLayoutAlign="center center" fxLayoutGap="32px">
                @if (data['confirmLabel']) {
                    <button mat-raised-button class="danger-btn" [mat-dialog-close]="data['name']">{{ data['confirmLabel'] }}</button>
                } @else {
                    <button mat-raised-button [mat-dialog-close]="data['name']">Yes</button>
                }
                <button mat-raised-button cdkFocusInitial (click)="onNoClick()">No</button>
            </div>
        </div>
    } @else {
        <div class="action-buttons">
            <button style="width: 100% !important;" mat-button [mat-dialog-close]="data['name']" cdkFocusInitial>Ok</button>
        </div>
    }
</div>
